import { V2Card, V2Button, Icon } from '@sakhtar/design-system/react';

/**
 * Step 1 — "welcome". No payload of its own (`SETUP_STEP_KEYS[0]`); its
 * only real action is completing it (advances the resume pointer to
 * `base-organization` server-side — `completeSetupStep`). Setup can no
 * longer be skipped or deferred from any step, this one included — the
 * repo owner's explicit decision (2026-09-27): the whole run must be
 * completed linearly.
 *
 * UI_REFERENCE_SOURCE: no dedicated frame in any of the 4 canonical
 * Onboarding files — confirmed by rendering all 4; see
 * `SetupWizardPage.tsx`'s own doc comment for the full reasoning (Phase A's
 * screens are the pre-signup trial flow, not this post-signup wizard; Phase
 * B/C start directly with module Q&A / team). status: KIT_CONFORMANT — a
 * real, backend-driven step (PR #137) built on design-system primitives
 * directly, same pattern as this app's other board-less utility screens
 * (e.g. Projects' `TasksPage.tsx`/`TodosPage.tsx`).
 */
export function WelcomeStep({
  onContinue,
  busy,
  error,
}: {
  onContinue: () => void;
  busy: boolean;
  error: string | null;
}) {
  return (
    <V2Card>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 16,
          padding: '40px 32px',
          textAlign: 'center',
        }}
      >
        <div
          style={{
            width: 56,
            height: 56,
            borderRadius: 'var(--sk-r-lg)',
            background: 'color-mix(in oklch, var(--sk-brand-500), transparent 85%)',
            color: 'var(--sk-brand-500)',
            display: 'grid',
            placeContent: 'center',
          }}
        >
          <Icon name="building" size="lg" />
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
          <h1 style={{ margin: 0, fontSize: 'var(--sk-fs-2xl)', fontWeight: 700 }}>
            به ساختار خوش آمدید
          </h1>
          <p
            style={{
              margin: 0,
              maxWidth: 440,
              fontSize: 'var(--sk-fs-md)',
              color: 'var(--sk-fg-muted)',
              lineHeight: 1.8,
            }}
          >
            پیش از شروع کار، چند تنظیم پایه برای سازمان شما لازم است. این راه‌اندازی فقط یک مرحلهٔ
            کوتاه دیگر دارد.
          </p>
        </div>

        {error ? (
          <div
            style={{
              width: '100%',
              padding: '10px 14px',
              borderRadius: 'var(--sk-r-md)',
              background: 'var(--sk-danger-soft)',
              border: '1px solid color-mix(in oklch, var(--sk-danger), transparent 78%)',
              fontSize: 13,
              color: 'var(--sk-fg)',
            }}
          >
            {error}
          </div>
        ) : null}

        <V2Button variant="primary" icon="chevronLeft" disabled={busy} onClick={onContinue}>
          {busy ? 'در حال ادامه…' : 'شروع راه‌اندازی'}
        </V2Button>
      </div>
    </V2Card>
  );
}
